import { render, staticRenderFns } from "./FoodsView.vue?vue&type=template&id=4f187273"
import script from "./FoodsView.vue?vue&type=script&lang=js"
export * from "./FoodsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports